// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"8ae2c732","375":"b30e57f7","695":"5ce9da93","800":"805c2f22"}[chunkId] + ".chunk.js";
};